import type { Routes } from '@angular/router';
import {
    PageContentType,
    ServicesFeature,
    createActionTriggerDealer,
    createMetaResolverWithDealer,
    defaultTitleResolver,
    ngrxLoaderGuard,
} from '@hyundai/ng-common-lib';
import { ServiceFormSlug } from '@hyundai/shared-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

export default [
    {
        path: '',
        loadComponent: () => import('./services-page/services-page.component'),
        canActivate: [
            ngrxLoaderGuard({
                waitUntilLoadedSelector: ServicesFeature.state.selectIsLoadingHeroServices,
                dataToCheckSelector: ServicesFeature.state.selectServicesHero,
            }),
        ],
        providers: [
            provideState(ServicesFeature.state),
            provideEffects([ServicesFeature.effects]),
            createActionTriggerDealer(ServicesFeature.actions.loadServicesHero()),
        ],
        title: defaultTitleResolver('Unsere Hyundai Serviceleistungen'),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Maßgeschneiderte Serviceleistungen bei ${dealer.name} in ${dealer.city}. Jetzt Termin vereinbaren!`,
                };
            }),
        },
        data: {
            contentType: PageContentType.SERVICE,
        },
    },
    {
        path: ServiceFormSlug,
        loadComponent: () => import('./service-form-page/service-form-page.component'),
        canActivate: [
            ngrxLoaderGuard({
                redirectOnFailUrl: '/',
                waitUntilLoadedSelector: ServicesFeature.state.selectIsLoadingServiceForm,
                dataToCheckSelector: ServicesFeature.state.selectServiceFormContent,
            }),
        ],
        providers: [
            provideState(ServicesFeature.state),
            provideEffects([ServicesFeature.effects]),
            createActionTriggerDealer(ServicesFeature.actions.loadServiceForm()),
        ],
        title: defaultTitleResolver('Servicetermin vereinbaren'),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Vereinbaren Sie jetzt einen Servicetermin mit unserem Hyundai Werkstattservice bei ${dealer.name} in ${dealer.city}. `,
                };
            }),
        },
        data: {
            contentType: PageContentType.SERVICEFORM,
        },
    },
] satisfies Routes;
